module.exports = __webpack_public_path__ + "img/img3.56893eab.svg";